import ResourceService from './resource.service'

class ShiftService extends ResourceService {
  static get resource() {
    return 'shift'
  }
}

export default ShiftService
